module.exports = __webpack_public_path__ + "ec6954808717646d8852da9e815e4c7e.png";